import {
  addParticipant,
  AddParticipantType
  // modifySchedule,
} from "@/api/calendar";
import React from "react";
import { Button, message } from "antd";
import { userInfo } from "os";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import { Employee } from "@/types/chat";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
interface IProps {
  scheduleId: string;
  userData: any;
  isCreator: boolean;
  isParticipant: boolean;
  calendarType: any;
  closeHandle: Function;
  outerFlag: number;
  isCrossPlatform: number;
  scheduleAppId: string;
  scheduleTeamId: string;
  currentEmployee: any;
}

function AddToMyCalendar(props: IProps) {
  const {
    scheduleId,
    userData,
    closeHandle,
    isCreator,
    isParticipant,
    calendarType,
    outerFlag,
    isCrossPlatform,
    scheduleAppId,
    scheduleTeamId,
    currentEmployee
  } = props;
  const { t } = useTranslation("calendar");
  async function addCalendarToMine() {
    // 跨平台用户不允许加入日程，仅含内部用户的日程，外部用户均不能加入
    // 当前用户和日程信息比对 当前用户相对于日程是否是跨平台/外部联系/跨租户
    const { labelInfoList } = currentEmployee;
    let isExternal = false;
    if (labelInfoList && labelInfoList.length > 0) {
      // 通讯录存在内部用户也可能返回labelEnum==="EXTERNAL"的情况 所以必须用isShow加以佐证
      isExternal =
        labelInfoList.filter((item: any) => item.isShow === "1" && item.labelEnum === "EXTERNAL")
          .length > 0;
    }
    // 外部联系人 isExternal && app === currentUser.app && teamId === currentUser.teamId;
    // 跨平台 app !== currentUser.app 跨租户 app === currentUser.app && teamId !== currentUser.teamId
    // // outerFlag 0内部 1外部 isCrossPlatform 是否跨平台日程，0否 1是
    if (
      (outerFlag === 0 &&
        ((isExternal &&
          currentEmployee.app === scheduleAppId &&
          currentEmployee.teamId === scheduleTeamId) ||
          currentEmployee.app !== scheduleAppId ||
          (currentEmployee.app === scheduleAppId && currentEmployee.teamId !== scheduleTeamId))) ||
      (outerFlag === 1 && currentEmployee.app !== scheduleAppId)
    ) {
      return message.error(t("not support joining this schedule"));
    }
    try {
      const params: AddParticipantType = {
        scheduleId,
        user: {
          teamId: userData.team.teamId,
          userId: userData.userId,
          account: userData.account,
          imageUrl: userData.imageUrl,
          ddAppId: userData.ddAppId,
          userType: currentEmployee.userType,
          realName: userData.realName
        },
        acceptFlag: true
      };
      const [res, err] = await addParticipant(params);
      if (!err) {
        message.success("添加成功");
        closeHandle();
      } else {
        message.error("添加失败");
      }
    } catch (error) {
      message.error("添加失败");
    }
  }
  const addCalendarToMineHandle = debounce(addCalendarToMine, 699, {
    leading: true,
    trailing: false
  });
  return !isCreator && !isParticipant && calendarType !== 2 ? (
    <div>
      <Button style={{ marginLeft: "24px" }} type="primary" onClick={addCalendarToMineHandle}>
        添加到我的日程
      </Button>
    </div>
  ) : null;
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  return {
    currentEmployee: chat.currentEmployee || {}
  };
}

export default connect(mapStateToProps)(AddToMyCalendar);
